module.exports = __webpack_public_path__ + "static/media/golf-carousel-320x480.10c8302f.jpg";